import { createEmptyContact } from '../constants/formConfig';
import { Field } from './Field';

export function SchoolContacts({ contacts, errors, onChange }) {
  const updateContact = (index, key, value) => {
    const next = contacts.map((contact, i) =>
      i === index ? { ...contact, [key]: value } : contact,
    );
    onChange(next);
  };

  /** Only one additional contact is allowed (maps to Secondary_Advisor_* in CRM). */
  const canAddContact = contacts.length < 2;

  const addContact = () => {
    if (!canAddContact) return;
    onChange([...contacts, createEmptyContact()]);
  };

  const removeContact = (index) => {
    if (contacts.length === 1) return;
    onChange(contacts.filter((_, i) => i !== index));
  };

  return (
    <section className="section">
      <h2 className="section-title">School Contacts</h2>

      {contacts.map((contact, index) => {
        const prefix = `contact_${index}`;
        return (
          <div className="contact-block" key={contact.id}>
            {index > 0 ? (
              <div className="contact-card-header">
                <h3>Additional Contact {index}</h3>
                <button
                  type="button"
                  className="btn-text danger"
                  onClick={() => removeContact(index)}
                >
                  Remove
                </button>
              </div>
            ) : null}

            <div className="field-grid two">
              <Field
                label={index === 0 ? 'Competition Coordinator — First Name' : 'First Name'}
                required
                error={errors[`${prefix}_firstName`]}
              >
                <input
                  type="text"
                  value={contact.firstName}
                  onChange={(e) =>
                    updateContact(index, 'firstName', e.target.value)
                  }
                  autoComplete="given-name"
                  placeholder="First"
                />
              </Field>
              <Field
                label={index === 0 ? 'Last Name' : 'Last Name'}
                required
                error={errors[`${prefix}_lastName`]}
              >
                <input
                  type="text"
                  value={contact.lastName}
                  onChange={(e) =>
                    updateContact(index, 'lastName', e.target.value)
                  }
                  autoComplete="family-name"
                  placeholder="Last"
                />
              </Field>
            </div>

            <div className="field-grid" style={{ marginTop: 14 }}>
              <Field label="Coordinator’s Title">
                <input
                  type="text"
                  value={contact.title}
                  onChange={(e) => updateContact(index, 'title', e.target.value)}
                />
              </Field>
            </div>

            <div className="field-grid two" style={{ marginTop: 14 }}>
              <Field label="Phone" error={errors[`${prefix}_phone`]}>
                <input
                  type="tel"
                  value={contact.phone}
                  onChange={(e) =>
                    updateContact(index, 'phone', e.target.value)
                  }
                  autoComplete="tel"
                />
              </Field>
              <Field label="Email" required error={errors[`${prefix}_email`]}>
                <input
                  type="email"
                  value={contact.email}
                  onChange={(e) =>
                    updateContact(index, 'email', e.target.value)
                  }
                  autoComplete="email"
                />
              </Field>
            </div>
          </div>
        );
      })}

      <button
        type="button"
        className="btn-link"
        onClick={addContact}
        disabled={!canAddContact}
      >
        + Add additional contact
      </button>
    </section>
  );
}
